module.exports = __webpack_public_path__ + "img/parallel-gateway.dfb4ebaf.svg";